import md5 from "md5";
import axios from "axios";
import JSZip from "jszip";

/**
 * 判断指定变量是否为空
 * 几种条件：str为{"",undefined,"null",null,false,str=object&&str.length=0}
 * @param str
 * @returns {boolean}
 */
function isNull(str) {
    if (typeof str === "undefined" || str === "null" || str === "" || str === " " || str === null || str === false || (typeof str === "object" && str.length === 0)) {
        return true;
    }
    return false;
}

/**
 * 获取当前页面的语言类型
 * @return {string}
 */
function getLanguage() {
    let language = isNull(document.querySelector('meta[name="language"]'))
        ? (isNull(document.querySelector("html")) ? 'cn' : document.querySelector("html").getAttribute('lang'))
        : document.querySelector('meta[name="language"]').content;
    if (isNull(language)) {
        language = 'cn';
    }
    return language;
}

/**
 * 获取全局变量
 * @param key
 * @return {*}
 */
function getGlobalData(key) {
    let val = sessionStorage.getItem(key);// 使用会话
    if (!isNull(val)) {
        val = JSON.parse(val);
    } else {
        val = '';
    }
    return val
}

/**
 * 设置全部变量
 * @param key
 * @param val
 */
function setGlobalData(key, val) {
    sessionStorage.setItem(key, JSON.stringify(val));// 使用会话
}

/**
 * 获取签名串
 * @param {string | object} params
 * @returns {string}
 */
function getSign(params) {
    if (typeof params == "string") {
        return paramsStrSort(params);
    } else if (typeof params == "object") {
        let arr = [];
        for (let i in params) {
            arr.push((i + "=" + params[i]));
        }
        return paramsStrSort(arr.join(("&")));
    }
}

/**
 * 对url串进行排序拼接
 * @param {string} paramsStr
 * @returns {string}
 */
function paramsStrSort(paramsStr) {
    let urlStr = paramsStr.split("&").sort().join("");
    return md5(urlStr);
}

/**
 * HTTP GET 请求
 * @param api API接口地址
 * @param data 请求查询{a=1,b=2}
 * @param feedback 请求结束后回调函数
 */
function requestGet(api, data = {}, feedback = function () {
}) {
    if (isNull(api)) {
        feedback(false);
    }
    axios.get(api, {params: data})
        .then(function (response) {
            if (response.status === 200) {
                feedback(response.data);
            } else {
                feedback(false);
            }
        }).catch(function (error) {
        feedback({code: 10000, message: error});
    });
}

/**
 * HTTP POST 请求
 * @param api API接口地址
 * @param data 请求查询{a=1,b=2}
 * @param feedback 请求结束后回调函数
 */
function requestPost(api, data = {}, feedback = function () {
}) {
    if (isNull(api)) {
        feedback(false);
    }
    axios.post(api, data)
        .then(function (response) {
            if (response.status === 200) {
                feedback(response.data);
            } else {
                feedback(false);
            }
        }).catch(function (error) {
        feedback({code: 10000, message: error});
    });
}

/**
 * 获取url中指定参数，参数通过斜杠传递
 * @param {string} url URL地址
 * @param {string} split 分隔符
 * @param {int} index 索引 从0开始,从http:// 上的斜杠开始计算
 * @returns {string}
 */
function getUrlParams(url = '', split = "/", index = 0) {
    let query = isNull(url) ? (isNull(window.location.href) ? '' : window.location.href) : url;
    let vars = query.split(split);
    return vars[index] ?? '';
}

/**
 * 获取url中指定参数，参数通过问号传递
 * @param {string} url URL地址
 * @param {string} key 参数名称，如：pid
 * @returns {string}
 */
function getQueryVariable(url = '', key = 'pid') {
    let query = isNull(url) ? (isNull(window.location.search) ? '' : window.location.search.substring(1)) : url;
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] === key) {
            return pair[1] ?? '';
        }
    }
    return '';
}

/**
 * 产生随机数
 * @param {int} len 长度，默认32位
 * @returns {String}
 */
function randomString(len) {
    len = len || 32;
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

/**
 * 创建并返回uuid，仅供标识使用
 * @returns string
 */
function createUid() {
    let uuid;
    let infos = getGlobalData('uuid');
    if (isNull(infos)) {
        let randStr = randomString(16);
        let timestamp = new Date().getTime();
        uuid = randStr + timestamp;
        let obj = {uuid: uuid, expire: (Date.now() + 86400000)};
        setGlobalData('uuid', JSON.stringify(obj));
    } else {
        infos = getGlobalData('uuid');
        if (isNull(infos)) {
            return '';
        }
        infos = JSON.parse(infos);
        uuid = infos.uuid;
    }
    return uuid;
}

/**
 * 字符串替换
 * @param {string} content 字符串
 * @param {string} FindText 查找的字符
 * @param {string} RepText 替换的字符
 * @returns {string}
 */
function replaceAll(content = "", FindText = "\n", RepText = "<br/>") {
    return content.replace(new RegExp(FindText.replace(/([\(\)\[\]\{\}\^\$\+\-\*\?\.\"\'\|\/\\])/g, "\\$1"), "ig"), RepText);
}

/**
 * 给字段串加颜色,替换大括号
 * @param {string} content 字符串
 * @param {array} RepText 替换后的内容
 * @param {array} FindText 查找的字符
 * @returns {string}
 */
function formatText(content = "", RepText = ['<div>', '</div>'], FindText = ['{', '}']) {
    if (isNull(content) || isNull(FindText) || isNull(RepText)) {
        return '';
    }
    let t1 = content.replace(new RegExp(FindText[0].replace(/([\(\)\[\]\{\}\^\$\+\-\*\?\.\"\'\|\/\\])/g, "\\$1"), "ig"), RepText[0]);
    return t1.replace(new RegExp(FindText[1].replace(/([\(\)\[\]\{\}\^\$\+\-\*\?\.\"\'\|\/\\])/g, "\\$1"), "ig"), RepText[1]);
}

/**
 * 获取页面宽度
 * @returns {int}
 */
function getWidth() {
    return document.querySelector('body').clientWidth;
}


/**
 * 浏览器名称+版本
 * @return {string}
 */
function getBrowser() {
    let broName = 'unknow';
    let userAgent = window.navigator.userAgent.toLowerCase(); // 包含以下属性中所有或一部分的字符串：appCodeName,appName,appVersion,language,platform
    if (userAgent.indexOf('firefox') !== -1) {// FireFox
        broName = 'Firefox';
    } else if (userAgent.indexOf('edge') !== -1) {// Edge
        broName = 'Edge';
    } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {// IE浏览器
        broName = 'IE';
    } else if (userAgent.indexOf('qqbrowser') !== -1) {// qqbrowser浏览器
        broName = 'QQbrowser';
    } else if (userAgent.indexOf('wow') !== -1 && userAgent.indexOf('net') < 0 && userAgent.indexOf('firefox') < 0) {// 360极速模式可以区分360安全浏览器和360极速浏览器
        broName = '360极速浏览器-极速模式';
    } else if (userAgent.indexOf('wow') !== -1 && userAgent.indexOf('net') !== -1 && userAgent.indexOf('msie') !== -1 && userAgent.indexOf('rv') < 0) {// 360兼容
        broName = '360兼容模式';
    } else if (userAgent.indexOf('safari') !== -1) {// Chrome浏览器
        broName = 'Safari';
    } else if (userAgent.indexOf('opera') !== -1) {// opera
        broName = 'Opera';
    } else if (userAgent.indexOf('micromessenger') !== -1) {// 微信浏览器
        broName = 'Micromessenger';
    } else if (userAgent.indexOf('chrome') !== -1) {// Chrome浏览器
        broName = 'Chrome';
    }
    return broName;
}

/**
 * 获取用户系统平台
 * @return {string}
 */
function getPlatform() {
    let ua = navigator.userAgent.toLowerCase();//浏览器
    let platform = navigator.platform.toLowerCase();
    if (ua.indexOf('iphone') !== -1) {
        platform = 'iphone';
    } else if (ua.indexOf('android') !== -1) {
        platform = 'android';
    } else if (ua.indexOf('windows') !== -1) {
        platform = 'windows';
    } else if (ua.indexOf('mac') !== -1) {
        platform = 'mac';
    }
    return platform;
}

/**
 * 判断是否微信浏览器
 * @returns {Boolean}
 */
function isWeixin() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

/**
 * 读取压缩包内的文件内容
 * @param url 压缩包所在的远程地址
 * @param type 文件读取格式，默认：base64，可选：{base64,uint8array,string}
 * @param feedBack 文件读取完成后回调
 * @return {boolean} 默认直接返回 false
 */
function readZip(url = '',type='base64', feedBack = function (files) {}) {
    if (isNull(url)) {
        return false;
    }
    let zip = new JSZip();
    let result = {};
    let total = 0;//总共多少个文件
    let process = 0;//已经处理了多少个文件
    axios.get(url, {responseType: 'blob'})
        .then(function (response) {
            if (response.status === 200 || response.status === 0) {
                zip.loadAsync(response.data)
                    .then(function (zip) {
                        total = Object.keys(zip.files).length;
                        // return zip.file("MolusG60-Animation-01/MolusG60-Animation-01-01.png").async("base64")
                        for (let key in zip.files) {//内置函数,判断是否是文件夹
                            if (!zip.files[key].dir) {
                                let names = zip.files[key].name.split('/');
                                if (isNull(names[1])) {
                                    process++;
                                    continue;
                                }
                                zip.file(zip.files[key].name).async(type).then(function (res) {
                                    result[names[1]] = res;
                                    process++;
                                }).then(function () {
                                    // console.log("total="+total,"process="+process);
                                    if (total == process) {
                                        feedBack(result);
                                    }
                                });
                            } else {
                                process++;
                            }
                        }
                    });
            } else {
                feedBack(false);
            }
        });
}

export default {
    randomString, createUid, replaceAll, isNull, getLanguage, getBrowser, getPlatform,
    requestGet, requestPost, getUrlParams, getQueryVariable, getSign, paramsStrSort,
    setGlobalData, getGlobalData, getWidth, isWeixin, formatText, readZip
}
